import { render, staticRenderFns } from "./UploadLogo.vue?vue&type=template&id=3ce62a98"
import script from "./UploadLogo.vue?vue&type=script&lang=js"
export * from "./UploadLogo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports